import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { SBRMFormActionProps, useSBRMForm } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import MetadataKey from '@utils/MetadataKey'
import { Form, Input } from 'antd'
import { requiredRule } from '../../../utils/rules'
import { Localizable } from '../../localizable/Localizable'

const Create = ({ form, formProps }: SBRMFormActionProps) => {
  const { getMetadata } = useSBRMForm()

  return (
    <Form
      {...formProps}
      form={form}
      layout="vertical"
      initialValues={{ venue: getMetadata(MetadataKey.Venue) }}
    >
      <Form.Item name="venue" hidden required rules={[]}>
        <Input />
      </Form.Item>
      <Localizable.Input
        name="title"
        rules={[requiredRule()]}
        label={'Title'}
        max={70}
      />
      <Form.Item name="venues" rules={[requiredRule()]} label={'Venues'}>
        <SBAsyncSelect
          entity={Entity.venue}
          multiple
          allowClear
          searchFieldName="name"
        />
      </Form.Item>
    </Form>
  )
}

export default Create
